import { HolderOutlined } from "@ant-design/icons"
import { type HTMLAttributes } from "react"
import styled from "styled-components"

const SDragHandleSpan = styled.span`
  cursor: grab;
  color: #8c8c8c;
  display: inline-flex;
  align-items: center;
`

/** Drag handle visual + a holder icon. Wire `draggable`, `onDragStart`,
 *  `onDragEnd`, and `onClick` from the parent. Kept as a small wrapper so
 *  callers don't repeat the cursor/color styling. */
export const DragHandle = (
  props: HTMLAttributes<HTMLSpanElement> & { draggable?: boolean }
) => (
  <SDragHandleSpan {...props}>
    <HolderOutlined />
  </SDragHandleSpan>
)
